var render = function render(){var _vm=this,_c=_vm._self._c;return _c('teacher-wizard',{attrs:{"current-step":_vm.currentStep,"steps":_vm.steps},scopedSlots:_vm._u([{key:"default",fn:function({currentStep}){return [_c(`Step${currentStep}`,{tag:"component",attrs:{"profile-data":_vm.profile},on:{"change-step":_vm.changeStep,"school-dpa-signed":_vm.schoolDpaSigned}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }